/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import { MenuProvider, ProviderMenuItem } from '@irian-ro/menu-provider-module';
import { Injectable, Optional } from '@angular/core';
import { UserContext } from '@irian-ro/util-user';

@Injectable()
export class AuthMenuProvider implements MenuProvider {
  menuItems: Array<ProviderMenuItem> = [];

  constructor(@Optional() private readonly userContext: UserContext) {
    if (!userContext) {
      throw new Error('Provide UserContext in app.module');
    }
  }

  getMenuItems(): Array<ProviderMenuItem> {
    this.menuItems = [];
    if (this.userContext.hasAnyRights(['ROLE_ADMIN', 'ROLE_UTILIZATORI'])) {
      this.menuItems.push({
        label: 'Utilizatori',
        weight: '55',
      });

      this.menuItems.push({
        label: 'Lista utilizatori',
        routerLink: '/auth/users',
        weight: '55.100',
      });

      this.menuItems.push({
        label: 'Lista autentificari',
        routerLink: '/auth/authLogs',
        weight: '55.200',
      });
    }

    return this.menuItems;
  }
}
